import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { replaceqbix900hl8kl as replace } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { Decoder2ddeqv6fq19z5 as Decoder } from './Decoder.js.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  readByteArray1fhzfwi2j014k as readByteArray,
  readByteArray1ri21h2rciakw as readByteArray_0,
} from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { encodeISO88591v742do8ms7fc as encodeISO88591 } from './ISO88591.mjs';
import {
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { encodeToImpl35qnqj6vvbsjt as encodeToImpl } from './Encoding.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      forName_etcah2_k$(name) {
        switch (name) {
          case 'UTF-8':
          case 'utf-8':
          case 'UTF8':
          case 'utf8':
            return Charsets_getInstance().UTF_8__1;
        }
        var tmp;
        var tmp_0;
        switch (name) {
          case 'ISO-8859-1':
          case 'iso-8859-1':
            tmp_0 = true;
            break;
          default:
            // Inline function 'kotlin.let' call

            var it = replace(name, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
            var tmp_1;
            if (it === 'iso-8859-1') {
              tmp_1 = true;
            } else {
              // Inline function 'kotlin.text.lowercase' call
              // Inline function 'kotlin.js.asDynamic' call
              tmp_1 = it.toLowerCase() === 'iso-8859-1';
            }

            tmp_0 = tmp_1;
            break;
        }
        if (tmp_0) {
          tmp = true;
        } else {
          tmp = name === 'latin1' || name === 'Latin1';
        }
        if (tmp) {
          return Charsets_getInstance().ISO_8859_1__1;
        }
        throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Charset ' + name + ' is not supported');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var CharsetClass;
function Charset() {
  if (CharsetClass === VOID) {
    class $ {
      constructor(_name) {
        this._name_1 = _name;
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !(this.constructor == other.constructor))
          return false;
        if (!(other instanceof Charset()))
          THROW_CCE();
        return this._name_1 === other._name_1;
      }
      hashCode() {
        return getStringHashCode(this._name_1);
      }
      toString() {
        return this._name_1;
      }
    }
    initMetadataForClass($, 'Charset');
    CharsetClass = $;
  }
  return CharsetClass;
}
var CharsetsClass;
function Charsets() {
  if (CharsetsClass === VOID) {
    class $ {
      constructor() {
        Charsets_instance = this;
        this.UTF_8__1 = new (CharsetImpl())('UTF-8');
        this.ISO_8859_1__1 = new (CharsetImpl())('ISO-8859-1');
      }
    }
    initMetadataForObject($, 'Charsets');
    CharsetsClass = $;
  }
  return CharsetsClass;
}
var Charsets_instance;
function Charsets_getInstance() {
  if (Charsets_instance === VOID)
    new (Charsets())();
  return Charsets_instance;
}
var CharsetDecoderClass;
function CharsetDecoder() {
  if (CharsetDecoderClass === VOID) {
    class $ {
      constructor(_charset) {
        this._charset_1 = _charset;
      }
    }
    initMetadataForClass($, 'CharsetDecoder');
    CharsetDecoderClass = $;
  }
  return CharsetDecoderClass;
}
var MalformedInputExceptionClass;
function MalformedInputException() {
  if (MalformedInputExceptionClass === VOID) {
    class $ extends IOException() {
      constructor(message) {
        return new.target.new_io_ktor_utils_io_charsets_MalformedInputException_brqco0_k$(message);
      }
      static new_io_ktor_utils_io_charsets_MalformedInputException_brqco0_k$(message) {
        var $this = this.new_kotlinx_io_IOException_wvwdyo_k$(message);
        captureStack($this, $this.$throwableCtor_3);
        return $this;
      }
    }
    initMetadataForClass($, 'MalformedInputException');
    MalformedInputExceptionClass = $;
  }
  return MalformedInputExceptionClass;
}
function get_name(_this__u8e3s4) {
  return _this__u8e3s4._name_1;
}
function forName(_this__u8e3s4, name) {
  return Companion_instance.forName_etcah2_k$(name);
}
var CharsetEncoderClass;
function CharsetEncoder() {
  if (CharsetEncoderClass === VOID) {
    class $ {
      constructor(_charset) {
        this._charset_1 = _charset;
      }
    }
    initMetadataForClass($, 'CharsetEncoder');
    CharsetEncoderClass = $;
  }
  return CharsetEncoderClass;
}
function decode(_this__u8e3s4, input, dst, max) {
  var decoder = Decoder(get_name(get_charset(_this__u8e3s4)), true);
  input.request_hj5jqj_k$(fromInt(max));
  var tmp0 = input.get_buffer_bmaafd_k$().get_size_woubt6_k$();
  // Inline function 'kotlin.comparisons.minOf' call
  var b = fromInt(max);
  var count = tmp0 <= b ? tmp0 : b;
  var array = readByteArray(input, convertToInt(count));
  var tmp;
  try {
    // Inline function 'org.khronos.webgl.toInt8Array' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = decoder.decode_hpap4q_k$(array);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var cause = $p;
      var tmp0_elvis_lhs = cause.message;
      throw MalformedInputException().new_io_ktor_utils_io_charsets_MalformedInputException_brqco0_k$('Failed to decode bytes: ' + (tmp0_elvis_lhs == null ? 'no cause provided' : tmp0_elvis_lhs));
    } else {
      throw $p;
    }
  }
  var result = tmp;
  dst.append_jgojdo_k$(result);
  return result.length;
}
function encodeImpl(_this__u8e3s4, input, fromIndex, toIndex, dst) {
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(fromIndex <= toIndex)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  if (get_charset_0(_this__u8e3s4).equals(Charsets_getInstance().ISO_8859_1__1)) {
    return encodeISO88591(input, fromIndex, toIndex, dst);
  }
  // Inline function 'kotlin.require' call
  if (!(get_charset_0(_this__u8e3s4) === Charsets_getInstance().UTF_8__1)) {
    var message_0 = 'Only UTF-8 encoding is supported in JS';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
  }
  var encoder = new TextEncoder();
  // Inline function 'kotlin.text.substring' call
  var tmp$ret$5 = toString(charSequenceSubSequence(input, fromIndex, toIndex));
  var result = encoder.encode(tmp$ret$5);
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  dst.write$default_fa5nq1_k$(result);
  return result.length;
}
function encodeToByteArray(_this__u8e3s4, input, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
  return encodeToByteArrayImpl(_this__u8e3s4, input, fromIndex, toIndex);
}
var CharsetImplClass;
function CharsetImpl() {
  if (CharsetImplClass === VOID) {
    class $ extends Charset() {
      newEncoder_gqwcdg_k$() {
        return new (CharsetEncoderImpl())(this);
      }
      newDecoder_zcettw_k$() {
        return new (CharsetDecoderImpl())(this);
      }
    }
    initMetadataForClass($, 'CharsetImpl');
    CharsetImplClass = $;
  }
  return CharsetImplClass;
}
function get_charset(_this__u8e3s4) {
  return _this__u8e3s4._charset_1;
}
function get_charset_0(_this__u8e3s4) {
  return _this__u8e3s4._charset_1;
}
function encodeToByteArrayImpl(_this__u8e3s4, input, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
  var start = fromIndex;
  if (start >= toIndex)
    return new Int8Array(0);
  var dst = new (Buffer())();
  var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, dst);
  start = start + rc | 0;
  if (start === toIndex) {
    return readByteArray_0(dst);
  }
  encodeToImpl(_this__u8e3s4, dst, input, start, toIndex);
  return readByteArray_0(dst);
}
var CharsetEncoderImplClass;
function CharsetEncoderImpl() {
  if (CharsetEncoderImplClass === VOID) {
    class $ extends CharsetEncoder() {
      constructor(charset) {
        super(charset);
        this.charset_1 = charset;
      }
      toString() {
        return 'CharsetEncoderImpl(charset=' + this.charset_1.toString() + ')';
      }
      hashCode() {
        return this.charset_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CharsetEncoderImpl()))
          return false;
        if (!this.charset_1.equals(other.charset_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CharsetEncoderImpl');
    CharsetEncoderImplClass = $;
  }
  return CharsetEncoderImplClass;
}
var CharsetDecoderImplClass;
function CharsetDecoderImpl() {
  if (CharsetDecoderImplClass === VOID) {
    class $ extends CharsetDecoder() {
      constructor(charset) {
        super(charset);
        this.charset_1 = charset;
      }
      toString() {
        return 'CharsetDecoderImpl(charset=' + this.charset_1.toString() + ')';
      }
      hashCode() {
        return this.charset_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CharsetDecoderImpl()))
          return false;
        if (!this.charset_1.equals(other.charset_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CharsetDecoderImpl');
    CharsetDecoderImplClass = $;
  }
  return CharsetDecoderImplClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Charsets_getInstance as Charsets_getInstancezrqwjk0yrlyw,
  MalformedInputException as MalformedInputExceptionbvc6h5ij0ias,
  decode as decode3smkguvhgu00o,
  encodeImpl as encodeImpl2q4xw7zvyejjm,
  encodeToByteArray as encodeToByteArrayomtvgs5lyogm,
  forName as forName2faodmskqnoz5,
  get_name as get_name2f11g4r0d5pxp,
};
//endregion

//# sourceMappingURL=Charset.js.mjs.map
